import { render } from "./ResetPassword.vue?vue&type=template&id=1ba60c19&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=1ba60c19&lang=scss&scoped=true"
import "./ResetPassword.vue?vue&type=style&index=1&id=1ba60c19&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba60c19"]])

export default __exports__